import styled, { css, DefaultTheme } from "styled-components";
import { ArrowProps } from "./types";

const modifier = {
  next: () => css`
    transform: rotate(0deg);
  `,
  prev: () => css`
    transform: rotate(180deg);
  `,
  light: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.portoSeguros05};
    > svg {
      fill: ${theme.colors.portoSeguros100};
    }
  `,
  dark: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.portoSeguros05};
    > svg {
      fill: ${theme.colors.portoBanking15};
    }
  `,
  overlay: (theme: DefaultTheme) => css`
    background: linear-gradient(
      to right,
      ${theme.colors.white} 7.51%,
      ${theme.colors.alpha} 100%
    );
  `,
};

export const Container = styled.div<Pick<ArrowProps, "overlay">>`
  ${({ theme, overlay }) => css`
    background: transparent;

    ${overlay && modifier.overlay(theme)}
    @media all and (max-width: ${theme.breakpoints.tabletLandscape}) {
      display: none;
    }
  `}
`;

export const ArrowWrapper = styled.button<ArrowProps>`
  ${({ theme, variant, mode }) => css`
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s background ease;

    ${!!variant && modifier[variant]()}
    ${!!mode && modifier[mode](theme)}

		> svg {
      position: absolute;
      left: 18px;
    }

    &:hover {
      background-color: ${theme.colors.portoSegurosPrimary};

      > svg {
        fill: ${theme.colors.portoSeguros15};
        transition: 0.3s fill ease;
      }
    }

    &:active {
      background-color: ${theme.colors.portoSeguros100};

      > svg {
        fill: ${theme.colors.portoBanking15};
      }
    }
  `}
`;
